import { createModalStore } from '@/shared/lib/modal';

export const useQueueOverloadedPaywallModalStore = createModalStore();
